import { smartyConfig } from '@/config';

export const SMARTY_HOST = 'https://us-autocomplete-pro.api.smartystreets.com/';
export const MAX_RESULTS = '5';
export const SMARTY_URL = `${SMARTY_HOST}lookup?key=${smartyConfig.key}&${smartyConfig.license}&prefer_geolocation=none&max_results=${MAX_RESULTS}`;
